import { Injectable } from '@angular/core';
import {
  FvActionSheetOption,
  FvActionsheetComponent,
} from '@discocil/fv-components';
import { GlobalFVComponent } from '../../interface/global-component.model';

@Injectable({
  providedIn: 'root',
})
export class GlobalActionSheetService extends GlobalFVComponent<FvActionsheetComponent> {

  get isOpened(): boolean {
    return this._currentComponent.isOpened;
  }

  open(options: FvActionSheetOption[]): void {
    if (this._currentComponent?.isOpened) {
      this.close();
    }

    this._currentComponent.open(options);
  }

  close(): void {
    this._currentComponent.close();
  }
}
